import moment from 'moment';
import {Link} from 'react-router-dom';
import {ReactComponent as NotificationIcon} from '../../../../assets/images/icons/notification.svg';
import {ReactComponent as Logo} from '../../../../assets/images/logo.svg';
import useNotifications from '../../../common/hooks/useNotifications';
import {useI18n} from '../../../common/providers/I18nProvider';

export default function Notifications() {
	const {i18n} = useI18n();
	const {data} = useNotifications({initialItemPerPage: 2});

	return (
		<div className='sm:bg-white sm:p-6 sm:rounded-lg'>
			<div className='flex justify-between mb-4 sm:mb-7'>
				<div className='flex items-center'>
					<NotificationIcon className='h-6 w-6 sm:h-7 sm:w-7 lg:h-8 lg:w-8' />
					<span className='text-[16px] sm:text-[18px] md:text-[22px] font-medium text-black-10 ml-3'>
						{i18n('DASHBOARD.NOTIFICATION.TITLE')}
					</span>
				</div>
				<div>
					{data?.data[0] && (
						<Link className='text-queen-blue text-sm md:text-base lg:text-xl font-bold' to='/dashboard/notifications'>
							{i18n('DASHBOARD.NOTIFICATION.BUTTON.ALL')}
						</Link>
					)}
				</div>
			</div>

			{(data?.data ?? []).map((notification) => (
				<div key={notification.id} className='mb-7'>
					<div className='flex items-center'>
						<div className='mr-4'>
							<Logo />
						</div>
						<div className='flex flex-col'>
							<span className='text-black-10 text-[14px] sm:text-[16px] md:text-[20px] font-medium'>
								{notification.title}
							</span>
							<span className='text-black-10 text-[12px] sm:text-[14px] md:text-[18px] break-all sm:break-all'>
								{notification.description}
							</span>
							<span className='text-black-50 text-[10px] sm:text-[12px] md:text-[16px] font-medium'>
								{moment(notification.created_at).format('MM/DD (ddd) HH:mm')}
							</span>
						</div>
					</div>
				</div>
			))}

			{!data?.data[0] && <div>{i18n('COMMON.NO.RECORDS')}</div>}
		</div>
	);
}
